import React, { useState, useEffect } from 'react';
import { useMappedState } from 'redux-react-hook';
import { message, Avatar, Alert, Form, Modal, Switch, Tooltip, Badge, Popconfirm, Popover, Icon, Button, Tag, Select, Input, Table, Skeleton, Tabs, Card, Statistic, Row, Col } from "antd";
import { flexCenterRight, formItemLayout } from './../theme';
import { createCustomJob, updateSavedJob, deleteSavedJob, saveJob, getSavedJobs, getNewJobs, getJobStats } from './../API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import { allNationsWithCaptial } from './../utils/countries';
import { format } from 'timeago.js';
import moment from 'moment';
import parse from 'html-react-parser';
import SavedJob from './savedJob';
import { editorConfig, FUNCTION, COMPANY } from './../utils';
import { funcColours } from './../utils/colours';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

import { Treemap } from '@ant-design/plots';

const { orderBy, groupBy, sumBy } = require('lodash');

const { TabPane } = Tabs;
const { Search } = Input;
const { Option } = Select;

const convertCountryName = (code, nations) => {
  const found = nations.find((i) => i.code === code);
  return found.name;
}

const buildPWCJobMoreInfo = (job) => {
  return (
    <div>
      <div><b>Location:&nbsp;</b>{job.meta.location}</div>
      <div><b>Grade:&nbsp;</b>{job.meta.grade}</div>
      <div><b>Specialism:&nbsp;</b>{job.meta.specialism}</div>
      <div><b>Industry:&nbsp;</b>{job.meta.industry}</div>
    </div>
  )
}

const buildKPMGJobMoreInfo = (job) => {
  return (
    <div>
      Not Available
    </div>
  )
}

const buildJobMoreInfo = (job) => {
  if (job.isCustomType && job.meta && job.meta.desc) {
    return parse(job.meta.desc)
  }
  return <div>Not Available</div>;
}

const buildSingaporeGovMoreInfo = (job) => {
  return (
    <div>
      <div><b>Categories:&nbsp;</b>{job.meta.categories.map((i) => i.category).toString()}</div>
      <div><b>Employment Types:&nbsp;</b>{job.meta.employmentTypes.map((i) => i.employmentType).toString()}</div>
      <div><b>Position Levels:&nbsp;</b>{job.meta.positionLevels.map((i) => i.position).toString()}</div>
      <div><b>Salary:&nbsp;</b>{`${job.meta.salary.minimum} - ${job.meta.salary.maximum} / ${job.meta.salary.type.salaryType}`}</div>
    </div>
  )
}

const buildMoreInfo = (job) => {
  switch (job.companyName) {
    case COMPANY.PWC:
      return buildPWCJobMoreInfo(job);
    case COMPANY.KPMG:
      return buildKPMGJobMoreInfo(job);
    case COMPANY.SINGAPORE_GOV:
      return buildSingaporeGovMoreInfo(job);
    default:
      return buildJobMoreInfo(job);
  }
}

const buildArr = (a) => {
  if (a && a.trim() !== '') {
    if (!a.includes(',')) {
      return [a];
    }
    return a.split(',')
  }
  return [];
}

const buildKeywords = (and, or) => {
  if (or && or.length > 0) {
    return or.map((i) => {
      if (and) {
        return [...[i], ...and].join(' <b>AND</b> ')
      } else {
        return i;
      }
    }).join(' <b>OR</b> ')
  }
  if (and && and.length > 0) {
    return and.join(' <b>AND</b> ');
  }
  return '';
}

const buildSavedJobs = (savedJobs) => {
  return savedJobs.filter((i) => !i.isCustomType);
}

const buildCustomJobs = (savedJobs) => {
  return savedJobs.filter((i) => i.isCustomType);
}

function JobForm({ form }) {
  const { getFieldDecorator } = form;

  let nations = allNationsWithCaptial();
  nations = [...nations, ...[{ code: 'All', name: 'All' }]];

  const session = useMappedState(state => state.session);
  const app = useMappedState((state) => state.app);

  const [showResumes, setShowResumes] = useState(false);
  const [showEditSearch, setShowEditSearch] = useState(false);

  const [updateLoading, setUpdateLoading] = useState(false);
  const [activeLoading, setActiveLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const [jobStats, setJobStats] = useState({
    companies: [],
    countries: [],
    functions: [],
  });
  const [jobs, setJobs] = useState([]);
  const [savedJobs, setSavedJobs] = useState([]);
  const [customJobs, setCustomJobs] = useState([]);
  const [entry, setEntry] = useState(null);

  const [searchCountryInSavedJob, setSearchCountryInSavedJob] = useState('All');
  const [searchCompanyInSavedJob, setSearchCompanyInSavedJob] = useState('All');

  const [searchCompany, setSearchCompany] = useState('All');
  const [searchCountry, setSearchCountry] = useState('All');
  const [searchFunction, setSearchFunction] = useState('All');
  const [search, setSearch] = useState('');
  const [savedJobSearch, setSavedJobSearch] = useState('');

  const [location, setLocation] = useState(null);
  const [and, setAnd] = useState(null);
  const [or, setOr] = useState(null);

  const [openCustomModal, setOpenCustomModal] = useState(false);
  const [descBody, setDescBody] = useState('');
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const dataResponse = await Promise.all([
        getJobStats(session.authToken),
        getNewJobs(session.authToken),
        getSavedJobs(session.authToken),
      ]);
      setLoading(false);
      setJobStats(dataResponse[0].data.data);
      setJobs(dataResponse[1].data.data);
      setSavedJobs(buildSavedJobs(dataResponse[2].data.data));
      setCustomJobs(buildCustomJobs(dataResponse[2].data.data));
    }
    fetchData();
    // eslint-disable-next-line
  }, []);

  const renderCard = (color, number, text, prefix, suffix) => {
    return (
      <Card size="small" style={{ marginLeft: '5px', marginRight: '5px', backgroundColor: color }}>
        {
          prefix ? (
            <Statistic title="" valueStyle={{ fontSize: '28px', color: '#fff' }} value={number} prefix={prefix} suffix={suffix} />
          ) : (
            <Statistic title="" valueStyle={{ fontSize: '28px', color: '#fff' }} value={number} suffix={suffix} />
          )
        }
        <Row>
          <Col span={18}>
            <div style={{ color: 'white' }}>{text}</div>
          </Col>
          <Col span={6}>
            <div style={flexCenterRight}>
              <FontAwesomeIcon
                style={{
                  cursor: 'pointer',
                  marginTop: '5px',
                  fontSize: '14px',
                  color: 'white'
                }} icon={faInfoCircle} />
            </div>
          </Col>
        </Row>
      </Card>
    )
  }

  const shared = [
    {
      title: 'Company',
      width: '5%',
      key: 'company',
      render: j =>
        <div>
          {
            j.companyId !== 3 ? (
              <Avatar shape="square" size={48} src={`${process.env.PUBLIC_URL}/${j.companyName}.jpg`} />
            ) : (
              <div>
                {
                  j.meta.postedCompany.logoUploadPath ? (
                    <div style={{ width: '48px', height: '48px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <img alt={`${j.title}`} src={j.meta.postedCompany.logoUploadPath} style={{ maxWidth: '100%', maxHeight: '100%' }} />
                    </div>
                  ) : (
                    <Avatar shape="square" size={38} src={`${process.env.PUBLIC_URL}/singapore.svg`} />
                  )
                }
              </div>
            )
          }
        </div>

    },
    {
      title: 'Country',
      width: '8%',
      key: 'country',
      render: j =>
        <div>
          {convertCountryName(j.country, nations)}
        </div>
    },
    {
      title: 'Function',
      width: '5%',
      key: 'function',
      render: j =>
        <div>
          <Tag color={funcColours[j.function.toLowerCase()]}><span style={{ fontWeight: 'bold' }}>{j.function}</span></Tag>
        </div>
    },
    {
      title: '',
      width: '1%',
      key: 'meta',
      render: j =>
        <Popover
          overlayStyle={{
            width: '28vw',
          }}
          placement="right"
          title="More Infomation"
          content={
            <>
              {
                j.meta ? (
                  buildMoreInfo(j)
                ) : null
              }
              {
                j.search ? (
                  <>
                    <br />
                    <Card>
                      <div><b>Keywords:&nbsp;</b>{parse(buildKeywords(buildArr(j.search.and), buildArr(j.search.or)))}</div>
                      <div><b>Locations:&nbsp;</b>{j.search.locations}</div>
                    </Card>
                  </>
                ) : null
              }
            </>
          }
        >
          <Icon type="exclamation-circle" theme="filled" style={{ fontSize: '16px', color: '#7CB9E8' }} />
        </Popover>
    },
  ]

  const jobColumns = [
    ...shared,
    ...[
      {
        title: <span>Job Title (<Badge color='pink' dot><span style={{ fontSize: '11px' }}>New Job Today</span></Badge>)</span>,
        width: '25%',
        key: 'title',
        render: j =>
          <div>
            {
              todayIDs.includes(j._id) ? (
                <Badge color='pink' dot>
                  <a href={j.link} target="_blank" rel="noopener noreferrer">{j.title}</a>
                </Badge>
              ) : (
                <a href={j.link} target="_blank" rel="noopener noreferrer">{j.title}</a>
              )
            }
            <div>{j.companyId === 3 && <b style={{ fontSize: '12px' }}>{j.searchCompany}</b>}</div>
            <div>
              <span style={{ color: '#aaa', fontSize: '12px' }}>
                <i>created at:&nbsp;{format(new Date(moment(j.createdAt).format('YYYY-MM-DD HH:mm:ss')))}</i>
              </span>
            </div>
          </div>
      },
      {
        title: '',
        width: '5%',
        render: (j) => <div style={flexCenterRight}>
          <Popconfirm
            disabled={combinedSavedJobIDs.includes(`${j.companyId}-${j.country}-${j.id}`)}
            placement="left"
            title="Are you sure to save this job?"
            onConfirm={async () => {
              setSaveLoading(true);
              setEntry(j);
              const result = await saveJob(
                session.authToken,
                {
                  _id: j._id,
                  id: j.id,
                  companyId: j.companyId,
                  country: j.country,
                }
              );
              if (result.data.responseCode === 0) {
                const res = await getSavedJobs(session.authToken);
                setSavedJobs(buildSavedJobs(res.data.data));
                setCustomJobs(buildCustomJobs(res.data.data));
                message.success(result.data.message);
              }
              else {
                message.error(result.data.message.toString());
              }
              setSaveLoading(false);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button
              disabled={combinedSavedJobIDs.includes(`${j.companyId}-${j.country}-${j.id}`)}
              type="primary"
              size="small"
            >
              {
                saveLoading && entry._id === j._id ?
                  <Icon type="loading" />
                  :
                  <Icon type="download" />
              }
              &nbsp;Save
            </Button>
          </Popconfirm>
        </div>
      }
    ]
  ]

  const customJobColumns = [
    {
      title: 'Function',
      width: '5%',
      key: 'function',
      render: j =>
        <div>
          <Tag color={funcColours[j.function.toLowerCase()]}><span style={{ fontWeight: 'bold' }}>{j.function}</span></Tag>
        </div>
    },
    {
      title: '',
      width: '1%',
      key: 'meta',
      render: j =>
        <Popover
          overlayStyle={{
            width: '25vw',
          }}
          placement="right"
          title="More Infomation"
          content={
            <>
              {
                j.meta ? (
                  buildMoreInfo(j)
                ) : (
                  <div>Not Available</div>
                )
              }
              {
                j.search ? (
                  <>
                    <br />
                    <Card>
                      <div><b>Keywords:&nbsp;</b>{parse(buildKeywords(buildArr(j.search.and), buildArr(j.search.or)))}</div>
                      <div><b>Locations:&nbsp;</b>{j.search.locations}</div>
                    </Card>
                  </>
                ) : null
              }
            </>
          }
        >
          <Icon type="exclamation-circle" theme="filled" style={{ fontSize: '16px', color: '#7CB9E8' }} />
        </Popover>
    },
    {
      title: 'Job Title',
      width: '25%',
      key: 'title',
      render: j =>
        <div>
          <Badge count={j.totalResumeCount} overflowCount={999}>
            <span>{j.title}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          </Badge>
        </div>
    },
    {
      title: 'Updated At',
      width: '10%',
      key: 'createdAt',
      render: j =>
        <div>
          <Badge style={{ backgroundColor: '#B0BF1A' }} count={findTodayNumber(j)} overflowCount={999}>
            {format(new Date(moment(j.createdAt).format('YYYY-MM-DD HH:mm:ss')))}
          </Badge>
        </div>
    },
    {
      title: '',
      width: '5%',
      render: (j) => <div style={flexCenterRight}>
        <Tooltip title={!j.search.locations && !j.search.add ? 'Complete Search' : ''}>
          <Switch
            disabled={!j.search.locations && !j.search.add}
            loading={activeLoading && entry._id === j._id}
            size="small"
            defaultChecked={j.activeSearch}
            onChange={async () => {
              setActiveLoading(true);
              setEntry(j);
              const result = await updateSavedJob(
                session.authToken,
                {
                  id: j._id,
                  type: 'active',
                  active: !j.activeSearch,
                }
              );
              if (result.data.responseCode === 0) {
                const res = await getSavedJobs(session.authToken);
                setSavedJobs(buildSavedJobs(res.data.data));
                setCustomJobs(buildCustomJobs(res.data.data));
                message.success(result.data.message);
              }
              else {
                message.error(result.data.message.toString());
              }
              setActiveLoading(false);
            }}
          />
        </Tooltip>
        &nbsp;&nbsp;
        <Tooltip title={j.totalResumeCount > 999 ? `Re-define Search (Total: ${j.totalResumeCount})` : 'Resumes'}>
          <Button
            disabled={j.totalResumeCount > 999}
            type="default"
            size="small"
            onClick={() => {
              setShowResumes(true);
              setEntry(j);
            }}
          >
            <Icon type="team" />
          </Button>
        </Tooltip>
        &nbsp;
        <Tooltip title="Edit Search">
          <Button
            type="default"
            size="small"
            onClick={() => {
              setShowEditSearch(true);
              setLocation(j.search.locations);
              setAnd(j.search.and);
              setOr(j.search.or);
              setEntry(j);
            }}
          >
            <Icon type="form" />
          </Button>
        </Tooltip>
        &nbsp;
        <Popconfirm
          placement="left"
          title={<div>
            <p>Are you sure to delete this custom job?</p>
            <div>
              <i style={{ color: '#bbb' }}>Warning: all related resumes will be deleted!</i>
            </div>
          </div>}
          onConfirm={async () => {
            /* saveLoading and setSaveLoading used for delete */
            setSaveLoading(true);
            setEntry(j);
            const result = await deleteSavedJob(
              session.authToken,
              { id: j._id }
            );
            if (result.data.responseCode === 0) {
              const res = await getSavedJobs(session.authToken);
              setSavedJobs(buildSavedJobs(res.data.data));
              setCustomJobs(buildCustomJobs(res.data.data));

              const statsRes = await getJobStats(session.authToken);
              setJobStats(statsRes.data.data);

              message.success(result.data.message);
            }
            else {
              message.error(result.data.message.toString());
            }
            setSaveLoading(false);
          }}
          okText="Yes"
          cancelText="No"
        >
          <Tooltip title="Delete">
            <Button
              type="danger"
              size="small"
            >
              {
                saveLoading && entry._id === j._id ?
                  <Icon type="loading" />
                  :
                  <Icon type="delete" />
              }
            </Button>
          </Tooltip>
        </Popconfirm>
      </div>
    }
  ]

  const savedJobColumns = [
    ...shared,
    ...[
      {
        title: 'Job Title',
        width: '25%',
        key: 'title',
        render: j =>
          <div>
            <Badge count={j.totalResumeCount} overflowCount={999}>
              <a href={j.link} target="_blank" rel="noopener noreferrer">{j.title}</a>
            </Badge>
            {
              j.date ? (
                <div>
                  <span style={{ color: '#aaa', fontSize: '12px' }}>
                    <i>{format(new Date(moment(j.date).format('YYYY-MM-DD HH:mm:ss')))}</i>
                  </span>
                </div>
              ) : null
            }
          </div>
      },
      {
        title: 'Updated At',
        width: '10%',
        key: 'createdAt',
        render: j =>
          <div>
            <Badge style={{ backgroundColor: '#B0BF1A' }} count={findTodayNumber(j)} overflowCount={999}>
              {format(new Date(moment(j.createdAt).format('YYYY-MM-DD HH:mm:ss')))}
            </Badge>
          </div>
      },
      {
        title: '',
        width: '5%',
        render: (j) => <div style={flexCenterRight}>
          <Tooltip title={!j.search.locations && !j.search.add ? 'Complete Search' : ''}>
            <Switch
              disabled={!j.search.locations && !j.search.add}
              loading={activeLoading && entry._id === j._id}
              size="small"
              defaultChecked={j.activeSearch}
              onChange={async () => {
                setActiveLoading(true);
                setEntry(j);
                const result = await updateSavedJob(
                  session.authToken,
                  {
                    id: j._id,
                    type: 'active',
                    active: !j.activeSearch,
                  }
                );
                if (result.data.responseCode === 0) {
                  const res = await getSavedJobs(session.authToken);
                  setSavedJobs(buildSavedJobs(res.data.data));
                  setCustomJobs(buildCustomJobs(res.data.data));
                  message.success(result.data.message);
                }
                else {
                  message.error(result.data.message.toString());
                }
                setActiveLoading(false);
              }}
            />
          </Tooltip>
          &nbsp;&nbsp;
          <Tooltip title={j.totalResumeCount > 999 ? `Re-define Search (Total: ${j.totalResumeCount})` : 'Resumes'}>
            <Button
              disabled={j.totalResumeCount > 999}
              type="default"
              size="small"
              onClick={() => {
                setShowResumes(true);
                setEntry(j);
              }}
            >
              <Icon type="team" />
            </Button>
          </Tooltip>
          &nbsp;
          <Tooltip title="Edit Search">
            <Button
              type="default"
              size="small"
              onClick={() => {
                setShowEditSearch(true);
                setLocation(j.search.locations);
                setAnd(j.search.and);
                setOr(j.search.or);
                setEntry(j);
              }}
            >
              <Icon type="form" />
            </Button>
          </Tooltip>
          &nbsp;
          <Popconfirm
            placement="left"
            title={<div>
              <p>Are you sure to delete this saved job?</p>
              <div>
                <i style={{ color: '#bbb' }}>Warning: all related resumes will be deleted!</i>
              </div>
            </div>}
            onConfirm={async () => {
              /* saveLoading and setSaveLoading used for delete */
              setSaveLoading(true);
              setEntry(j);
              const result = await deleteSavedJob(
                session.authToken,
                { id: j._id }
              );
              if (result.data.responseCode === 0) {
                const res = await getSavedJobs(session.authToken);
                setSavedJobs(buildSavedJobs(res.data.data));
                setCustomJobs(buildCustomJobs(res.data.data));
                message.success(result.data.message);
              }
              else {
                message.error(result.data.message.toString());
              }
              setSaveLoading(false);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button
                type="danger"
                size="small"
              >
                {
                  saveLoading && entry._id === j._id ?
                    <Icon type="loading" />
                    :
                    <Icon type="delete" />
                }
              </Button>
            </Tooltip>
          </Popconfirm>
        </div>
      }
    ]
  ];

  /******************************************
   * todayData 找出所有公司当天的成功的reminders
   * todayIDs 找出所有的新的job的_id
  ******************************************/
  const todayData = app.jobReminder.map((i) => {
    return {
      ...i,
      ...{
        data: i.data.filter((i) => moment(i.createdAt).isSame(moment(), 'day') && i.status === 'success')
      }
    }
  });
  const ops = [];
  for (const each of todayData) {
    for (const every of each.data) {
      const foundJobs = jobs.filter((i) => i.companyId === every.companyId && i.country === every.country)
        .filter((e) => every.meta.newJobs.includes(e.id));
      ops.push(foundJobs.map((i) => i._id))
    }
  }
  const todayIDs = ops.flat();
  /******************************************
   * end todayData / todayIDs
   ******************************************/


  /****************************************************
   * resumeTodayData 找出所有当天的成功的resume reminders
   * 从 group 公司名 切换到 group savedJob
   * 需要找到 savedJob 今天有多少个新的更新
  *****************************************************/
  const resumeTodayData = app.resumeReminder.map((i) => {
    return {
      ...i,
      ...{
        data: i.data.filter(
          (i) => moment(i.createdAt).isSame(moment(), 'day') &&
            i.status === 'success'
        )
      }
    }
  });

  const groupedSavedJobs = () => {
    const ops = [];
    for (const each of resumeTodayData) {
      for (const every of each.data) {
        ops.push(every)
      }
    }
    const groupedOps = groupBy(ops, 'savedJob');
    const groupedOpsArr = Object.keys(groupedOps).map(e => {
      return {
        savedJob: e,
        count: sumBy(groupedOps[e].map((i) => i.meta.newResumes.length))
      }
    })
    return groupedOpsArr
  }

  const totalNewResumes = sumBy(groupedSavedJobs(), 'count');

  const findTodayNumber = (j) => {
    const found = groupedSavedJobs().find((i) => i.savedJob === j._id);
    return found ? found.count : 0
  }
  /******************************************
   * end resumeTodayData
  ******************************************/


  let jobsData = jobs;
  if (searchCompany !== 'All') {
    jobsData = jobs.filter((i) => i.companyName === searchCompany);
  }
  if (searchCountry !== 'All') {
    jobsData = jobsData.filter((i) => i.country === searchCountry);
  }
  if (searchFunction !== 'All') {
    jobsData = jobsData.filter((i) => i.function === searchFunction);
  }
  jobsData = jobsData.filter(e => e.title.toLowerCase().includes(search.toLowerCase()));

  const dotJobs = jobsData.filter((i) => todayIDs.includes(i._id));
  const notDotJobs = jobsData.filter((i) => !todayIDs.includes(i._id));

  jobsData = [
    ...orderBy(dotJobs, 'createdAt', 'desc'),
    ...orderBy(notDotJobs, 'createdAt', 'desc'),
  ]

  let savedJobsData = savedJobs;
  if (searchCompanyInSavedJob !== 'All') {
    savedJobsData = savedJobsData.filter((i) => i.companyName === searchCompanyInSavedJob);
  }
  if (searchCountryInSavedJob !== 'All') {
    savedJobsData = savedJobsData.filter((i) => i.country === searchCountryInSavedJob);
  }
  savedJobsData = savedJobsData.filter(
    e => e.title.toLowerCase().includes(savedJobSearch.toLowerCase()) ||
      e.companyName.toLowerCase().includes(savedJobSearch.toLowerCase()) ||
      e.function.toLowerCase().includes(savedJobSearch.toLowerCase())
  )

  const combinedSavedJobIDs = savedJobs.map((i) => `${i.companyId}-${i.country}-${i.id}`);

  const andArr = buildArr(and);
  const orArr = buildArr(or);
  const keywords = buildKeywords(andArr, orArr);

  const chartData = {
    name: 'root',
    children: jobStats && jobStats.keywords ? jobStats.keywords.map((i) => {
      return {
        name: i._id,
        value: i.count,
      }
    }) : []
  };

  const config = {
    data: chartData,
    colorField: 'name',
  };

  return (
    loading ?
      <div>
        <p>Loading...</p>
        <Skeleton active />
      </div>
      :
      <div>
        <Modal
          width="80%"
          centered={true}
          title="Add New Custom Job"
          closable={false}
          visible={openCustomModal}
          footer={[
            <Button disabled={creating} key="cancel" onClick={() => {
              setOpenCustomModal(false);
              form.resetFields();
              setDescBody('');
            }}>
              <Icon type="close" />
              Cancel
            </Button>,
            <Button disabled={creating} type="primary" key="submit" onClick={async () => {
              const formResult = await form.validateFields(['function', 'title']);
              setCreating(true);
              const result = await createCustomJob(
                session.authToken,
                {
                  function: formResult.function,
                  title: formResult.title,
                  meta: {
                    desc: descBody
                  },
                  search: {
                    locations: '',
                    and: '',
                    or: '',
                  }
                }
              );
              if (result.data.responseCode === 0) {
                const res = await getSavedJobs(session.authToken);
                setSavedJobs(buildSavedJobs(res.data.data));
                setCustomJobs(buildCustomJobs(res.data.data));
                setOpenCustomModal(false);
                message.success(result.data.message);
              }
              else {
                message.error(result.data.message.toString());
              }
              setCreating(false);
            }}>
              {creating ? <Icon type="loading" /> : <Icon type="check" />}
              Submit
            </Button>
          ]}
        >
          <div>
            <Row>
              <Col span={12}>
                <Form.Item {...formItemLayout} label="Function">
                  {getFieldDecorator('function', {
                    rules: [{ required: true, message: 'Please select function!' }],
                  })(
                    <Select
                      disabled={creating}
                      placeholder="Select function"
                      style={{ width: '100%' }}
                    >
                      {
                        FUNCTION.map((i) => (
                          <Option key={i} value={i}>{i}</Option>
                        ))
                      }
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item {...{
                  labelCol: { span: 3 },
                  wrapperCol: { span: 21 },
                }} label="Job Title">
                  {getFieldDecorator('title', {
                    rules: [{ required: true, message: 'Please input job title!' }],
                  })(
                    <Input disabled={creating} autoComplete="off" placeholder="Input job title" />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={3} />
              <Col span={21}>
                <CKEditor
                  disabled={creating}
                  value={descBody}
                  data={descBody}
                  editor={Editor}
                  config={editorConfig}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setDescBody(data);
                  }}
                />
              </Col>
            </Row>
          </div>
        </Modal>
        <Modal
          width="98%"
          centered={true}
          title={
            <div>
              <span>{entry && entry.totalResumeCount > 0 ? `${entry.totalResumeCount} Resumes Available` : 'Resumes Not Available'}</span>
              <div style={{ float: 'right' }}>
                <span style={{ fontSize: '14px', fontWeight: 'normal' }}>Locations: {entry && entry.search && entry.search.locations}</span>
              </div>
            </div>
          }
          closable={false}
          visible={showResumes}
          footer={[
            <Button key="cancel" onClick={() => {
              setShowResumes(false);
              setEntry(null);
            }}>
              <Icon type="close" />
              Close
            </Button>
          ]}
        >
          {
            showResumes && entry ? (
              <SavedJob id={entry._id} />
            ) : null
          }
        </Modal>
        <Modal
          width="80%"
          centered={true}
          title={entry ? <a href={entry.link} target="_blank" rel="noopener noreferrer">{entry.title}</a> : ''}
          closable={false}
          visible={showEditSearch}
          footer={[
            <Button disabled={updateLoading} key="cancel" onClick={() => {
              setShowEditSearch(false);
              form.resetFields();
              setLocation(null);
              setAnd(null);
              setOr(null);
              setEntry(null);
            }}>
              <Icon type="close" />
              Cancel
            </Button>,
            <Button disabled={updateLoading} key="edit" type="primary" onClick={async () => {
              const formResult = await form.validateFields(['and', 'or', 'location']);
              setUpdateLoading(true);
              const search = {
                locations: formResult.location && formResult.location.trim() !== '' ? formResult.location : null,
                and: formResult.and && formResult.and.trim() !== '' ? formResult.and : null,
                or: formResult.or && formResult.or.trim() !== '' ? formResult.or : null,
              }
              const result = await updateSavedJob(
                session.authToken,
                {
                  id: entry._id,
                  type: 'search',
                  search,
                }
              );
              if (result.data.responseCode === 0) {
                const res = await getSavedJobs(session.authToken);
                setSavedJobs(buildSavedJobs(res.data.data));
                setCustomJobs(buildCustomJobs(res.data.data));
                setShowEditSearch(false);
                form.resetFields();
                setLocation(null);
                setAnd(null);
                setOr(null);
                setEntry(null);
                message.success(result.data.message);
              }
              else {
                message.error(result.data.message.toString());
              }
              setUpdateLoading(false);
            }}>
              {updateLoading ? <Icon type="loading" /> : <Icon type="check" />}
              Submit
            </Button>

          ]}
        >
          <div>
            <Alert
              message="Search Conditions"
              description={<div>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Keywords:&nbsp;</b>{parse(keywords)}</div>
                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Locations:&nbsp;</b>{location}</div>
              </div>}
              type="info"
            />
            <Row>
              <Col span={12}>
                <Form.Item label="AND" style={{ marginRight: '5px' }}>
                  {getFieldDecorator('and', {
                    initialValue: and,
                    rules: [{ required: true, message: 'Please input and!' }],
                  })(
                    <Input autoComplete="off" placeholder="AND Keywords" onChange={(e) => {
                      setAnd(e.target.value)
                    }} />
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="OR" style={{ marginLeft: '5px' }}>
                  {getFieldDecorator('or', {
                    initialValue: or,
                  })(
                    <Input autoComplete="off" placeholder="OR Keywords" onChange={(e) => {
                      setOr(e.target.value)
                    }} />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item label="Location" style={{ marginRight: '5px' }}>
                  {getFieldDecorator('location', {
                    initialValue: location,
                    rules: [{ required: true, message: 'Please input location!' }],
                  })(
                    <Input autoComplete="off" placeholder="Location" onChange={(e) => {
                      setLocation(e.target.value);
                    }} />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Modal>

        <Row>
          <Col span={6}>
            {renderCard('#B0BF1A', todayIDs.length, 'Today New Resumes / Jobs', `${totalNewResumes} /`, null)}
          </Col>
          <Col span={6}>
            {renderCard('#B284BE', jobStats.totalJobs, 'Total Resumes / Jobs', `${Number(jobStats.totalResumes).toLocaleString()} /`, null)}
          </Col>
          <Col span={6}>
            {renderCard('#72A0C1', jobStats.totalCountries, 'Total Countries')}
          </Col>
          <Col span={6}>
            {renderCard('#DE5D83', jobStats.totalCompanies, 'Total Companies')}
          </Col>
        </Row>
        <br />
        <Tabs type="card">
          <TabPane tab={<div><FontAwesomeIcon icon={faFileAlt} />&nbsp;&nbsp;New Jobs</div>} key="newjobs">
            <Row>
              <Col span={4} />
              <Col span={20}>
                <div style={flexCenterRight}>
                  Company:
                  &nbsp;&nbsp;
                  <Select
                    defaultValue={'All'}
                    placeholder="Select Company"
                    style={{ width: '150px' }}
                    onChange={(value) => {
                      setSearchCompany(value);
                    }}
                  >
                    {
                      [...['All'], ...jobStats.companies].map((i) => (
                        <Option key={i} value={i}>
                          {i}
                        </Option>
                      ))
                    }
                  </Select>
                  &nbsp;&nbsp;
                  Country:
                  &nbsp;&nbsp;
                  <Select
                    defaultValue={'All'}
                    optionFilterProp={'label'}
                    placeholder="Select Country"
                    style={{ width: '150px' }}
                    onChange={(value) => {
                      setSearchCountry(value);
                    }}
                  >
                    {
                      [...['All'], ...jobStats.countries.sort()].map((i) => (
                        <Option label={convertCountryName(i, nations)} key={i} value={i}>
                          {convertCountryName(i, nations)}
                        </Option>
                      ))
                    }
                  </Select>
                  &nbsp;&nbsp;
                  Function:
                  &nbsp;&nbsp;
                  <Select
                    defaultValue={'All'}
                    placeholder="Select Function"
                    style={{ width: '175px' }}
                    onChange={(value) => {
                      setSearchFunction(value);
                    }}
                  >
                    {
                      [...['All'], ...jobStats.functions].map((i) => (
                        <Option key={i} value={i}>
                          {i}
                        </Option>
                      ))
                    }
                  </Select>
                  &nbsp;&nbsp;
                  <Search
                    placeholder="Search"
                    style={{ width: 200 }}
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <br />
            <Table
              pagination={{ pageSize: 50 }}
              columns={jobColumns}
              dataSource={jobsData}
              rowKey="_id"
            />
          </TabPane>
          <TabPane tab={<div><FontAwesomeIcon icon={faFileExport} />&nbsp;&nbsp;Custom Jobs&nbsp;<Badge count={customJobs.length} style={{ backgroundColor: '#7CB9E8' }} /></div>} key="customjobs">
            <Row>
              <Col span={4} />
              <Col span={20}>
                <div style={flexCenterRight}>
                  <Button size="small" type="primary" onClick={() => {
                    setOpenCustomModal(true);
                  }}>
                    <Icon type="plus" /> Add New
                  </Button>
                </div>
              </Col>
            </Row>
            <br />
            <Table
              pagination={{ pageSize: 25 }}
              columns={customJobColumns}
              dataSource={orderBy(customJobs, 'createdAt', 'desc')}
              rowKey="_id"
            />
          </TabPane>
          <TabPane tab={<div><FontAwesomeIcon icon={faDownload} />&nbsp;&nbsp;Saved Jobs&nbsp;<Badge count={savedJobs.length} style={{ backgroundColor: '#7CB9E8' }} /></div>} key="savedjobs">
            <Row>
              <Col span={4} />
              <Col span={20}>
                <div style={flexCenterRight}>
                  Company:
                  &nbsp;&nbsp;
                  <Select
                    defaultValue={'All'}
                    placeholder="Select Company"
                    style={{ width: '150px' }}
                    onChange={(value) => {
                      setSearchCompanyInSavedJob(value);
                    }}
                  >
                    {
                      [...['All'], ...jobStats.companies].map((i) => (
                        <Option key={i} value={i}>
                          {i}
                        </Option>
                      ))
                    }
                  </Select>
                  &nbsp;&nbsp;
                  Country:
                  &nbsp;&nbsp;
                  <Select
                    defaultValue={'All'}
                    optionFilterProp={'label'}
                    placeholder="Select Country"
                    style={{ width: '150px' }}
                    onChange={(value) => {
                      setSearchCountryInSavedJob(value)
                    }}
                  >
                    {
                      [...['All'], ...jobStats.countries.sort()].map((i) => (
                        <Option label={convertCountryName(i, nations)} key={i} value={i}>
                          {convertCountryName(i, nations)}
                        </Option>
                      ))
                    }
                  </Select>
                  &nbsp;&nbsp;
                  <Search
                    placeholder="Search"
                    style={{ width: 200 }}
                    onChange={(e) => {
                      setSavedJobSearch(e.target.value);
                    }}
                  />
                </div>
              </Col>
            </Row>
            <br />
            <Table
              pagination={{ pageSize: 25 }}
              columns={savedJobColumns}
              dataSource={orderBy(savedJobsData, 'createdAt', 'desc')}
              rowKey="_id"
            />
          </TabPane>
          <TabPane tab={<div><FontAwesomeIcon icon={faChartBar} />&nbsp;&nbsp;Charts</div>} key="charts">
            <Treemap {...config} />
          </TabPane>
        </Tabs>
      </div>
  )
}

const Jobs = Form.create({ name: 'Jobs' })(JobForm);

export default Jobs;
